import { render, staticRenderFns } from "./roleBindForm.vue?vue&type=template&id=6a01fee2&scoped=true"
import script from "./roleBindForm.vue?vue&type=script&lang=js"
export * from "./roleBindForm.vue?vue&type=script&lang=js"
import style0 from "./roleBindForm.vue?vue&type=style&index=0&id=6a01fee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a01fee2",
  null
  
)

export default component.exports